import React, { PropsWithChildren } from 'react';
import cx from 'classnames';
import Button from '../../Button';
import { SearchBoxStyle } from './style';

interface SearchBoxProps {
  className?: string;
  onSearch: () => void;
  onClear: () => void;
}
const SearchBox = (props: PropsWithChildren<SearchBoxProps>) => {
  const { className, onSearch, onClear, children } = props;

  return (
    <SearchBoxStyle className={cx('search-box', className)}>
      {children}

      <div className="btn-area">
        <Button color="primary" text="검색" onClick={() => onSearch()} />

        <Button color="light" text="초기화" onClick={() => onClear()} />
      </div>
    </SearchBoxStyle>
  );
};

export default SearchBox;
